import { render, staticRenderFns } from "./WhySelect.vue?vue&type=template&id=48ecf9b6&scoped=true"
import script from "./WhySelect.vue?vue&type=script&lang=js"
export * from "./WhySelect.vue?vue&type=script&lang=js"
import style0 from "./WhySelect.vue?vue&type=style&index=0&id=48ecf9b6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.11.0_webpack@5.102.1__lodash@4_84c89ef1ca8e21ad744d928d5a51d316/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ecf9b6",
  null
  
)

export default component.exports